module.exports = __webpack_public_path__ + "static/img/UBC教室_2.a5a4c2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UBC/UBC教室_2.png
// module id = mwtw
// module chunks = 0